import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useResponsive } from 'hooks/useResponsive';
import { StatisticsCard } from './statisticsCard/StatisticsCard/StatisticsCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { FallOutlined, RiseOutlined } from '@ant-design/icons';
import { GetAllEmployees, Pagination } from '@app/api/employee.api';
import { useAppSelector } from '@app/hooks/reduxHooks';
const initialPagination: Pagination = {
  current: 1,
  pageSize: 10000000000000,
};
export interface EmpCountStatistic {
  Active: number;
  Inactive: number;
  TotalEmpCount: number;
}

interface IStatisticCard {
  // eslint-disable-next-line
  fnsetempdata: (data: any) => void;
}
export const StatisticsCards: React.FC<IStatisticCard> = ({ fnsetempdata }) => {
  const user = useAppSelector((state) => state.user.user);
  const FirmId = user?.AllowedFirms.find((obj) => obj.value === user?.DefualtFirmId)?.value || null;

  const [statistics, setStatistics] = useState<EmpCountStatistic>();

  const { isTablet } = useResponsive();

  const fetch = useCallback(
    async (pagination: Pagination, EmpcodeFilter: string, FirstNameFilter: string) => {
      await GetAllEmployees(pagination, EmpcodeFilter, FirstNameFilter, FirmId || 0)
        .then((res) => {
          if (res.data.length > 0) {
            fnsetempdata(res.data);
            const activeCount = res.data.reduce((count, employee) => {
              // Check for active status using a boolean property (replace 'isActive' with your actual property name)
              return count + (employee.IsActive ? 1 : 0);
            }, 0);

            const inactiveCount = res.data.length - activeCount;
            setStatistics({ Active: activeCount, Inactive: inactiveCount, TotalEmpCount: res.data.length });
          }
        })
        .catch((e) => {
          fnsetempdata(null);
          console.log(e);
        });
    },
    [FirmId, fnsetempdata],
  );

  useEffect(() => {
    fetch(initialPagination, '', '');
  }, [fetch]);

  const statisticsCards = useMemo(() => {
    return (
      <>
        <BaseCol key={1} xs={24} md={12} order={(isTablet && 1) || 0}>
          <StatisticsCard
            TotalCount={statistics?.TotalEmpCount || 0}
            name={'Active Employees'}
            value={statistics?.Active || 0}
            prevValue={0}
            color={'success'}
            unit={''}
            Icon={() => <RiseOutlined />}
          />
        </BaseCol>
        <BaseCol key={2} xs={24} md={12} order={(isTablet && 1) || 0}>
          <StatisticsCard
            TotalCount={statistics?.TotalEmpCount || 0}
            name={'In Active Employees'}
            value={statistics?.Inactive || 0}
            prevValue={0}
            color={'error'}
            unit={''}
            Icon={() => <FallOutlined />}
          />
        </BaseCol>
      </>
    );
  }, [isTablet, statistics?.Active, statistics?.Inactive, statistics?.TotalEmpCount]);

  return <>{statisticsCards}</>;
};
